// FAQs for the performance service. Extracted from the main service data file
// so the route's head() can import them without pulling in the full
// per-service content (which lives in the lazy chunk).
export const FAQS_PERFORMANCE = {
  en: [
    {
      q: "Could performance work affect my theme or apps?",
      a: "Any storefront change can introduce risk, so we work in an unpublished theme, record the apps and customer states affected, and run representative QA before production. We do not remove or defer an app without evidence and approval, and every release keeps a rollback and verification path.",
    },
    {
      q: "How do I know the result is real?",
      a: "We preserve the affected URL, template, viewport, connection and consent state, then repeat comparable lab tests after the change. We also monitor real-user field data over time. Search Console and CrUX use rolling windows, so we report deployment evidence separately from population-level validation.",
    },
    {
      q: "How long does a Shopify performance project take?",
      a: "Most fixed-scope engagements run 2–4 weeks. The exact plan depends on the number of affected templates, the app stack, the baseline evidence and the QA needed before release.",
    },
  ],
  es: [
    {
      q: "¿El trabajo de performance puede afectar mi theme o mis apps?",
      a: "Cualquier cambio de storefront puede introducir riesgo. Trabajamos en un theme no publicado, registramos apps y estados afectados y corremos QA representativo antes de producción. No eliminamos ni diferimos una app sin evidencia y aprobación, y cada release conserva rollback y verificación.",
    },
    {
      q: "¿Cómo sé que el resultado es real?",
      a: "Preservamos URL, template, viewport, conexión y estado de consentimiento, y repetimos pruebas comparables después del cambio. También monitoreamos datos reales con el tiempo. Search Console y CrUX usan ventanas móviles, así que separamos evidencia de deploy de validación poblacional.",
    },
    {
      q: "¿Cuánto dura un proyecto de performance?",
      a: "La mayoría de engagements de alcance fijo dura entre 2 y 4 semanas. El plan exacto depende de los templates afectados, el stack de apps, la evidencia inicial y el QA necesario antes del release.",
    },
  ],
};
